<template>
  <div class="lds">
    <div class="lds-facebook">
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Loader'
}
</script>

<style lang="scss" scoped>
.lds {
  position: absolute;
  top: 50%;
  left: 50%;
  &-facebook {
    display: block;
    position: relative;
    width: 80px;
    height: 80px;
    margin: 0 auto;
    transform: translate(-50%, -100%);
    div {
      display: inline-block;
      position: absolute;
      left: 8px;
      width: 16px;
      background: #2e76e4;
      animation: lds-facebook 0.4s cubic-bezier(0, 0.5, 0.5, 1) infinite;
      &:nth-child(1) {
        left: 8px;
        animation-delay: -0.24s;
      }
      &:nth-child(2) {
        left: 32px;
        animation-delay: -0.12s;
      }
      &:nth-child(2) {
        left: 32px;
        animation-delay: -0.12s;
      }
      &:nth-child(3) {
        left: 56px;
        animation-delay: 0;
      }
    }
  }
}
@keyframes lds-facebook {
  0% {
    top: 8px;
    height: 64px;
  }
  50%,
  100% {
    top: 24px;
    height: 32px;
  }
}
</style>
